/*
  PATISSLAND v4 : icones menu mobile + Compte en majuscules + harmonisation sous-titres,
  MOBILE UNIQUEMENT. Code deplace de layout/theme.liquid vers ce fichier le 28/10/2026
  (logique inchangee, le style .pl-nav-ico reste dans theme.liquid).
*/
    (function(){
var ICONS={
"nouveautes":'<svg class="pl-nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z"/><path d="M18.5 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8z"/></svg>',
"alimentaire":'<svg class="pl-nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 11a6 6 0 0 1 12 0"/><path d="M5 11h14l-1.6 8a2 2 0 0 1-2 1.6H8.6a2 2 0 0 1-2-1.6L5 11z"/><path d="M9.5 11v9.5M14.5 11v9.5"/></svg>',
"materiel":'<svg class="pl-nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.5 3.5l7 7"/><path d="M12 5l-8.2 8.2a3.5 3.5 0 0 0 0 5 3.5 3.5 0 0 0 5 0L17 10"/><path d="M12 5c2-2 5-2 7 0s2 5 0 7"/></svg>',
"themes":'<svg class="pl-nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l2.7 5.5 6 .9-4.3 4.2 1 6-5.4-2.8-5.4 2.8 1-6L3.3 9.4l6-.9L12 3z"/></svg>',
"ebooks":'<svg class="pl-nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 6c-1.8-1.6-4.2-2-8-2v15c3.8 0 6.2.4 8 2 1.8-1.6 4.2-2 8-2V4c-3.8 0-6.2.4-8 2z"/><path d="M12 6v15"/></svg>',
"compte":'<svg class="pl-nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4.5 20.5a7.5 7.5 0 0 1 15 0"/></svg>'
      };
// Sous-titres a harmoniser avec le style des liens voisins (jamais d icone)
var SUBS=["marques pro","boites","themes enfants"];
// Textes a ignorer completement
var SKIP=["compte fidelite"];
var MQ=window.matchMedia("(max-width:768px)");
function norm(s){return (s||"").normalize("NFD").split("").filter(function(ch){var c=ch.charCodeAt(0);return c<768||c>879;}).join("").replace(/\s+/g," ").trim().toLowerCase();}
function starts(t,k){if(t===k)return true;if(t.indexOf(k)!==0)return false;var c=t.charAt(k.length);return !/[a-z0-9]/.test(c);}
function inject(el,svg){
// Insere l icone juste avant le premier texte reel, pour rester en ligne avec le libelle
var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT,null),n=null,t;
while((t=w.nextNode())){if(t.nodeValue&&t.nodeValue.trim()){n=t;break;}}
var tmp=document.createElement("span");tmp.innerHTML=svg;var ico=tmp.firstChild;
if(n&&n.parentNode){n.parentNode.insertBefore(ico,n);}else{el.insertAdjacentHTML("afterbegin",svg);}
      }
function harmonize(el){
var list=el.closest("ul,ol");if(!list)return;
var ref=null;
list.querySelectorAll('a[href^="/collections/"]').forEach(function(a){if(!ref&&a!==el)ref=a;});
if(!ref)return;
var cs=getComputedStyle(ref);
        ["color","fontWeight","fontSize","fontFamily","letterSpacing","textTransform","opacity"].forEach(function(p){
el.style[p]=cs[p];
        });
      }
function apply(){
if(!MQ.matches)return; // mobile uniquement : ne jamais toucher au mega menu desktop
document.querySelectorAll("nav a, nav button, [class*='nav'] a, [class*='nav'] button, [class*='drawer'] a, [class*='drawer'] button, [class*='menu'] a, [class*='menu'] button").forEach(function(el){
if(el.dataset.plIco)return;
if(el.querySelector(".pl-nav-ico")){el.dataset.plIco="1";return;}
var t=norm(el.textContent);
if(!t)return;
var i;
for(i=0;i < SKIP.length;i++){if(starts(t,SKIP[i]))return;}
for(i=0;i < SUBS.length;i++){
if(starts(t,SUBS[i])){el.dataset.plIco="1";harmonize(el);return;}
          }
for(var k in ICONS){
if(starts(t,k)){
el.dataset.plIco="1";
inject(el,ICONS[k]);
if(k==="compte")el.classList.add("pl-nav-caps");
return;
            }
          }
        });
      }
// Execution au chargement puis deux rattrapages, aucun observateur permanent
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",apply);}else{apply();}
window.addEventListener("load",apply,{once:true});
setTimeout(apply,2500);
// Si l ecran passe en mobile apres coup (rotation, redimensionnement)
if(MQ.addEventListener){MQ.addEventListener("change",function(e){if(e.matches)apply();});}
    })();
